import React from "react";

import { appConstants } from "../config/app-constants";

type Props = {
	imgId: string;
};

const SvgImage: React.FC<Props> = (props: Props) => {
	const { imgId } = props;

	return (
		<svg className="eds-svg-img">
			<use href={`${appConstants.basePath}/assets/images/svg-images.svg#${imgId}`}></use>
		</svg>
	);
};

export default SvgImage;
